import React, { useState, useEffect, Fragment } from 'react';
import {
    Row, Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import Card from './components/Card';
import IntlMessages from '../../../../../helpers/IntlMessages';

function Index() {

    return (
        <Fragment>
            <Row className="">
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <div className="mb-4 w-80">
                        <h4><b><IntlMessages id='dashboards.publishAI' /></b></h4>
                        <p >  <IntlMessages id='dashboards.retrainAfterChanges' /></p>
                    </div>

                    <Fragment>
                        <Card />
                    </Fragment>
                </Colxx>
            </Row>

        </Fragment>
    );
}
export default Index;

